'use client';

import React, { useEffect, useState } from 'react';
import { PlayerActionsTab } from '@/app/dashboard/players/components/player-actions-tab';
import { PlayerDetailsTab } from '@/app/dashboard/players/components/player-details-tab';
import { PlayerJsonTab } from '@/app/dashboard/players/components/player-json-tab';
import { PlayerKYCTab } from '@/app/dashboard/players/components/player-kyc-tab';
import { PlayerKYCTabV2 } from '@/app/dashboard/players/components/player-kyc-tab-v2';
import { PlayerSettingsTab } from '@/app/dashboard/players/components/player-settings-tab';
import { PlayerStatsTab } from '@/app/dashboard/players/components/player-stats-tab';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { getUi } from '@/store/reducers/ui-slice';
import { Player, ServiceResponse } from '@alien-platform/bo-core';

import { PlayerTab } from '@/types/general';
import { TabSwitcher } from '@/components/core/tab-switcher';

export default function PlayerDetailsContent(): React.JSX.Element | null {
  const [playerData, setPlayerData] = useState<Player>();

  const { drawerState } = useAppSelector(getUi);
  const { PLAYER_DETAILS: data } = useAppSelector(getDrawerContent);
  const fetchPlayerData = async (): Promise<void> => {
    try {
      const response = await fetch(`/api/players`, {
        method: 'post',
        body: JSON.stringify({ playerId: data?.playerId, playerCode: data?.playerCode }),
      });
      const result: ServiceResponse<Player> = await response.json();
      if (response.ok && result.success && result.data) {
        setPlayerData(result.data);
      }
    } catch (e) {
      // empty block
    }
  };

  useEffect(() => {
    if (drawerState.PLAYER_DETAILS) void fetchPlayerData();
  }, [data]);

  const tabList = [
    {
      id: PlayerTab.DETAILS,
      label: 'Details',
      content: <PlayerDetailsTab playerData={playerData} />,
    },
    {
      id: PlayerTab.DETAILSJSON,
      label: 'JSON',
      content: <PlayerJsonTab playerData={playerData} />,
    },
    {
      id: PlayerTab.STATS,
      label: 'Player Stats',
      content: <PlayerStatsTab playerData={playerData} />,
    },
    {
      id: PlayerTab.ACTIONS,
      label: 'Actions',
      content: <PlayerActionsTab />,
    },
    {
      id: PlayerTab.KYC,
      label: 'Documents',
      content: <PlayerKYCTab playerData={playerData} />,
    },
    {
      id: PlayerTab.KYC_V2,
      label: 'KYC Documents',
      content: <PlayerKYCTabV2 playerData={playerData} />,
    },
    {
      id: PlayerTab.SETTINGS,
      label: 'Player Settings',
      content: <PlayerSettingsTab playerData={playerData} />,
    },
  ];

  if (!data?.playerId) return null;

  return <TabSwitcher tabList={tabList} />;
}
